import { IconNamesProps } from "./Icon"

const chevronleft = (props: IconNamesProps) => (
    <svg width="1em" height="1em" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7 13L1 7L7 1"
            stroke={props.color || "#000"}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default chevronleft
